import {
    Alert,
    Button,
    Card,
    Col,
    Divider,
    Form,
    message,
    Modal,
    Radio,
    Row,
    Space,
    Spin,
    Typography,
    Upload
} from "antd";
import {DownloadOutlined, ExclamationCircleOutlined, EyeOutlined, PlusOutlined} from "@ant-design/icons";
import React, {useEffect, useState} from "react";
import {CustomerVerificationWrapperDto} from "../../dto/CustomerVerificationWrapperDto";
import {CustomerVerificationTimeSlotsDto} from "../../dto/CustomerVerificationTimeSlotsDto";
import customerService from "../../service/customerService";
import {CustomerVerificationScheduleDayDto} from "../../dto/CustomerVerificationScheduleDayDto";
import {
    ALLOWED_IMAGE_TYPE_EXTENSION,
    ALLOWED_IMAGE_TYPES, ALLOWED_IMAGE_TYPES_TEXT,
    DOC_CODE_SIGNATURE_DOC,
    DOCUMENT_TYPES,
    PREVIEW_DOC_TYPES
} from "../../util/Constants";
import {
    MSG_ALLOWED_DOCUMENT_TYPES_ERROR,
    MSG_ALLOWED_IMAGE_TYPES_ERROR,
    MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR,
    MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR
} from "../../util/Messages";
import documentService from "../../service/documentService";
import {UploadedDocumentDetailDto} from "../../dto/UploadedDocumentDetailDto";
import ErrorHandler from "../../util/ErrorHandler";
import {toNumber} from "lodash";
import customerChangeRequestService from "../../service/customerChangeRequestService";
import {SignatureDto} from "../../dto/SignatureDto";
import modal from "antd/es/modal";
import PreviewModalComp from "../common/preview/PreviewModalComp";

const {Link, Paragraph} = Typography;

interface SignatureProps {
    cin: string
}

interface DefaultDocDto {
    uid: string
    name: string
    thumbUrl: string
    url: string
    documentTypeId: number
}

const uploadFileSize: number | undefined = process.env.UPLOAD_FILE_SIZE ? toNumber(process.env.UPLOAD_FILE_SIZE) : 4;
const configs = {
    name: 'file',
    multiple: false,
    maxCount: 1
};
const SignatureChangeRequestComp = (props: SignatureProps) => {
    const [dateSchedules, setDateSchedules] = useState<CustomerVerificationWrapperDto>();
    const [timeSchedules, setTimeSchedules] = useState<CustomerVerificationWrapperDto>();
    const [selectedDateSch, setSelectedDateSch] = useState('');
    const [isSpinnerLoad, setSpinnerLoad] = useState(false);
    const [signatureUploadedList, setSignatureUploadedList] = useState<DefaultDocDto[]>()
    const [previewOpen, setPreviewOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [previewTitle, setPreviewTitle] = useState('');
    const [videoLink, setVideoLink] = useState('');
    const [isAbleToEdit, setAbleToEdit] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [tempSignatureDocId, setTempSignatureDocId] = useState<number>(0);
    const [isCanVewOldSign, setCanVewOldSign] = useState<boolean>(false);
    const [signatureDetail, setSignatureDetail] = useState<SignatureDto>({});
    const [jobNumber, setJobNumber] = useState<string>("")
    const [currentSignatureDocument, setCurrentSignatureDocument] = useState<UploadedDocumentDetailDto>();
    const [isEditDisabled, setEditDisabled] = useState<boolean>(true)

    const [selectedTimeSlot, setSelectedTimeSlot] = useState<CustomerVerificationTimeSlotsDto>({
        slotStart: '',
        slotEnd: '',
        taken: false,
        slotId: 0
    });
    const [radioForm] = Form.useForm();
    const [signatureForm] = Form.useForm();
    useEffect(() => {
        getDatesSchedule();
        getSignatureDetails()
    }, [])
    const getSignatureDetails = () => {
        setSpinnerLoad(true)
        customerChangeRequestService.getCustomerSignatureDetail(props.cin).then(res => {
            setSignatureDetail(res.data.results)
            console.log(res.data.results)
            setAbleToEdit(res.data.results.isEditable)
            setVideoLink(res.data.results.videoLink)
            setJobNumber(res.data.results.jobNumber)
            loadUploadedDocuments(res.data.results.jobNumber, [DOC_CODE_SIGNATURE_DOC])
            setSpinnerLoad(false)
        }, (reason) => {
            setSpinnerLoad(false)

            ErrorHandler.handleError(reason);
        })
    }
    const getDatesSchedule = () => {
        setSpinnerLoad(true)
        customerService.getDateScheduleForVerification().then(res => {
            setSpinnerLoad(false)
            if (res.data !== null) {
                setDateSchedules(res.data.results)
                getTimeSlots(res.data.results.verificationScheduleDtoList[0].actualDate)
                setSelectedDateSch(res.data.results.verificationScheduleDtoList[0].actualDate)
            } else {
                message.error("Schedule fetching failed").then();
            }
        }).catch(reason => {
            setSpinnerLoad(false)
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Schedule fetching failed").then();
            }
        })
    }
    const getTimeSlots = (selectedDate: string) => {
        setSpinnerLoad(true)
        setSelectedDateSch(selectedDate)
        radioForm.resetFields()
        customerService.getTimeScheduleForVerification(selectedDate).then(res => {
            setSpinnerLoad(false)
            if (res.data !== null) {
                setTimeSchedules(res.data.results)
            } else {
                message.error("Time slots fetching failed").then();
            }
        }).catch(reason => {
            setSpinnerLoad(false)
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Time slots fetching failed").then();
            }
        })
    }

    const submitRequest = () => {

        signatureForm.validateFields().then(() => {
            if (selectedTimeSlot.slotStart == "") {
                message.warning("Please select a time slot!")
            } else {
                if (signatureUploadedList && signatureUploadedList.length > 0) {
                    if (tempSignatureDocId == signatureUploadedList[0].uid) {
                        signatureForm.setFields([
                            {
                                name: 'signature',
                                errors: ['Change signature document to continue']
                            }
                        ]);
                        return Promise.reject();
                    } else {
                        setSpinnerLoad(true)
                        modal.confirm({
                            title: 'Confirm',
                            icon: <ExclamationCircleOutlined/>,
                            content: `Are you sure?, Do you want to change the signature?`,
                            okText: 'Yes',
                            cancelText: 'No',
                            className: 'confirm-dialog-box',
                            okButtonProps: {style: {background: '#FF7400'}},
                            onOk() {
                                let signatureDto = signatureDetail
                                signatureDto.recordStatus = "SUBMITTED"
                                signatureDto.signatureDocId = toNumber(signatureUploadedList[0].uid)
                                signatureDto.cin = props.cin
                                signatureDto.requestedDate = selectedDateSch,
                                    signatureDto.requestedStartTime = selectedTimeSlot.slotStart,
                                    signatureDto.requestedEndTime = selectedTimeSlot.slotEnd,
                                    signatureDto.slotId = selectedTimeSlot.slotId
                                customerChangeRequestService.submitCustomerSignatureChangeRequest(signatureDto, props.cin).then((res) => {
                                    message.success("Successfully submitted to authorization")
                                    setSignatureDetail(res.data.results)
                                    setAbleToEdit(res.data.results.isEditable)
                                    setVideoLink(res.data.results.videoLink)
                                    setSignatureUploadedList([])
                                    setSpinnerLoad(false)
                                }, (reason) => {
                                    setSpinnerLoad(false)
                                    ErrorHandler.handleError(reason);
                                })
                            },
                            onCancel() {
                                setSpinnerLoad(false)
                            }
                        });

                    }
                }
            }
        }).catch(() => {
            message.warning("Please fill all required fields")
        })
    }
    const onClickDateSchBtn = (data: CustomerVerificationScheduleDayDto) => {
        getTimeSlots(data.actualDate)
        setSelectedTimeSlot({
            slotStart: '',
            slotEnd: '',
            taken: false,
            slotId: 0
        })
    }
    const loadUploadedDocuments = (jobNo: number, identityDocumentTypeCodeList: string[]) => {
        if (jobNo) {
            setSpinnerLoad(true)
            documentService.getUploadDocumentListByType(jobNo, identityDocumentTypeCodeList).then(res => {
                if (res.data !== null) {
                    setUploadedDocumentList(res.data.results)
                } else {
                    message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
                }
            }, (reason) => {
                ErrorHandler.handleError(reason);
            })
        }

    };
    const setUploadedDocumentList = (documents: any) => {

        documents.forEach((document: any) => {
            let uploadDocumentDetailDto: UploadedDocumentDetailDto = document.uploadDocumentDetailDto;

            if (uploadDocumentDetailDto) {
                setTempSignatureDocId(uploadDocumentDetailDto.uploadDocumentDetailId)
                setCanVewOldSign(true)
            } else {
                setCanVewOldSign(false)
            }
            createUploadedDocuments(uploadDocumentDetailDto, document.documentTypeId, 1)
        })
    };
    const beforeUploadSignature = (file: any) => {
        return validateDocument(file, DOCUMENT_TYPES.SIGN_TEMP, ALLOWED_IMAGE_TYPES);
    };

    const validateDocument = (file: any, type: number, allowedDocTypes: string[]) => {
        setSpinnerLoad(true)
        let indexOf = allowedDocTypes.indexOf(file.type);
        if (indexOf < 0) {

            message.error(JSON.stringify(allowedDocTypes) === JSON.stringify(ALLOWED_IMAGE_TYPES) ? MSG_ALLOWED_IMAGE_TYPES_ERROR : MSG_ALLOWED_DOCUMENT_TYPES_ERROR);
            setSpinnerLoad(false)
            return Upload.LIST_IGNORE;
        }
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            message.error(`Document must smaller than ${uploadFileSize}MB!`);
            setSpinnerLoad(false)
            return Upload.LIST_IGNORE;
        }

        const formData = new FormData();
        formData.append("files", file);
        formData.append("jobNo", jobNumber);

        formData.append("documentTypeId", JSON.stringify(type));

        documentService.uploadDocument(formData).then(res => {
            if (res.data !== null) {
                let results = res.data.results;
                let uploadDocumentDetailDto: UploadedDocumentDetailDto = results.uploadDocumentDetailDtoList[0];
                createUploadedDocuments(uploadDocumentDetailDto, uploadDocumentDetailDto.documentTypeId, 2)
                setSpinnerLoad(false)
            } else {
                setSpinnerLoad(false)
                message.error(MSG_FAILED_TO_UPLOAD_DOCUMENTS_ERROR).then();
            }
        }, (reason) => {
            setSpinnerLoad(false)
            ErrorHandler.handleError(reason);
        })
        return false;
    };

    const createUploadedDocuments = (uploadDocumentDetailDto: UploadedDocumentDetailDto, documentTypeId: number, type: number) => {
        setSpinnerLoad(false)
        let defaultFileList;
        if (undefined != uploadDocumentDetailDto) {
            if (type == 1) {
                console.log(uploadDocumentDetailDto)
                setCurrentSignatureDocument(uploadDocumentDetailDto)
            } else {
                defaultFileList =
                    [{
                        uid: uploadDocumentDetailDto.uploadDocumentDetailId.toString(),
                        name: uploadDocumentDetailDto.originalDocumentName,
                        thumbUrl: uploadDocumentDetailDto.thumbB64,
                        url: uploadDocumentDetailDto.thumbDocumentPath,
                        documentTypeId: documentTypeId
                    }]
            }
        } else {
            defaultFileList = undefined;
        }

        setSignatureUploadedList(defaultFileList)
        signatureForm.setFieldsValue({signature: defaultFileList})

    };
    const onRemove = (docId: number) => {
        if (docId != 0) {
            setSpinnerLoad(true)
            if (docId == DOCUMENT_TYPES.SIGN) {
                setSignatureUploadedList([])
                setSpinnerLoad(false)
                signatureForm.setFieldsValue({signature: []})


            } else {
                documentService.deleteDocumentById(signatureUploadedList[0].uid).then(res => {
                    if (res.data !== null) {
                        setSpinnerLoad(false)
                        setSignatureUploadedList([])
                        signatureForm.setFieldsValue({signature: []})

                    } else {
                        message.error(MSG_FAILED_TO_DELETE_DOCUMENTS_ERROR).then();
                        setSpinnerLoad(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setSpinnerLoad(false)
                })
            }
            return true;
        }

    };
    const normFile = (e: { fileList: any; }) => {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    };
    const onPreview = (documentId: string, docTypeName: string) => {
        setSpinnerLoad(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setIsModalOpen(false)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setSpinnerLoad(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setSpinnerLoad(false)
            }
        }, (reason) => {
            setSpinnerLoad(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
    };

    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    const onClickEdit = () => {
        setEditDisabled(!isEditDisabled)
        if (!isEditDisabled) {
            radioForm.resetFields()
            setSignatureUploadedList([])
        }
    }
    return (
        <Spin spinning={isSpinnerLoad}>
            {
                !isAbleToEdit ?
                    <Col span={24} style={{marginBottom: 8}}>
                        <Alert
                            message="A new request cannot be processed because a request has already been raised."
                            type="warning" showIcon/>
                    </Col> :
                    <Col span={24} className={'request-screen-edit-btn-position'}>
                        <Space style={{float: 'right'}}>
                            <Button
                                style={{
                                    width: 84,
                                }}
                                onClick={onClickEdit}
                            >
                                Edit
                            </Button>
                        </Space>
                    </Col>
            }
            <Row gutter={[24, 12]}>

                <Col xxl={10} xl={10} lg={10} md={24} sm={24} xs={24}>
                    <Card title={"Upload the New Signature"}

                    >
                        <Form
                            className='form-input'
                            layout={"vertical"}
                            form={signatureForm}
                            disabled={!isAbleToEdit || isEditDisabled}
                        >
                            <Row gutter={[24, 0]}>
                                <Col span={24}>
                                    <Row>
                                        {isCanVewOldSign ?
                                            <Col span={24}>
                                                <Form.Item
                                                    label="Current Signature">
                                                    <div className='utility_bill img-nic'>
                                                        <div className='utulity_bill_icon_div'>
                                                            <div className="img_div">
                                                                <img src={currentSignatureDocument?.thumbB64} alt=""/>
                                                            </div>
                                                            <div className='name_div'>
                                                                <h5>{currentSignatureDocument?.originalDocumentName}</h5>
                                                                {/*<h6>Size: 5MB </h6>*/}
                                                            </div>
                                                        </div>
                                                        <Button className='doc-view-btn'
                                                                onClick={() => onPreview(currentSignatureDocument ? String(currentSignatureDocument?.uploadDocumentDetailId) : '',
                                                                    currentSignatureDocument ? currentSignatureDocument?.originalDocumentName : '')}><EyeOutlined/></Button>
                                                    </div>
                                                </Form.Item>
                                            </Col> : <></>}
                                        <Col span={24}>
                                            <Form.Item
                                                label="New Signature"
                                                name={"signature"}
                                                getValueFromEvent={normFile}
                                                rules={[{required: true, message: 'Please upload your new signature'}]}
                                            >
                                                <Upload {...configs}
                                                        className='upload_comp'
                                                        accept={ALLOWED_IMAGE_TYPE_EXTENSION}
                                                        listType="picture"
                                                        onPreview={(e: any) => {
                                                            onPreview(signatureUploadedList ? signatureUploadedList[0].uid : '',
                                                                signatureUploadedList ? signatureUploadedList[0].name : '')
                                                        }}
                                                        onRemove={(e: any) => onRemove(signatureUploadedList ? signatureUploadedList[0].documentTypeId : 0)}
                                                        fileList={signatureUploadedList && signatureUploadedList?.length > 0 ? signatureUploadedList : undefined}
                                                        beforeUpload={beforeUploadSignature}
                                                >
                                                    {(undefined != signatureUploadedList ? signatureUploadedList.length : [].length) < 1 &&
                                                        <Button>
                                                            <div className='upload-btn-div'>
                                                                <div className="upload-icon-div">
                                                                    <PlusOutlined
                                                                        style={{fontSize: 20, color: '#757575'}}/>
                                                                </div>
                                                                <div className="upload-btn-text-div">
                                                                <span>
                                                                    Upload the New Signature {ALLOWED_IMAGE_TYPES_TEXT}
                                                                </span>
                                                                </div>
                                                            </div>
                                                        </Button>
                                                    }
                                                </Upload>
                                            </Form.Item>
                                        </Col>
                                        {/*{*/}
                                        {/*    !isAbleToEdit ?*/}
                                        {/*        <Col span={24}>*/}
                                        {/*            <Alert*/}
                                        {/*                message="Video Verification Meeting Link"*/}
                                        {/*                type="info" showIcon*/}
                                        {/*                action={*/}
                                        {/*                    <Link href={videoLink} target="_blank">*/}
                                        {/*                        <Paragraph style={{margin: 0}}*/}
                                        {/*                                   copyable={{text: '' + videoLink}}></Paragraph>*/}
                                        {/*                    </Link>*/}
                                        {/*                }*/}
                                        {/*            />*/}


                                        {/*        </Col> : ''*/}
                                        {/*}*/}
                                    </Row>
                                </Col>
                            </Row>
                        </Form>
                    </Card>
                </Col>
                <Col xxl={14} xl={14} lg={14} md={24} sm={24} xs={24}>
                    <Card title={"Schedule a Video Verification"}>
                        <Row>
                            <Col span={24}>
                                <Row gutter={32} style={{marginBottom: 4,}} className='dates-row'>
                                    {
                                        dateSchedules?.verificationScheduleDtoList.map((data, index) => {
                                            return <Col lg={8} sm={8} md={8} xs={8} className='dates-col' key={index}>
                                                <Button disabled={!isAbleToEdit || isEditDisabled} type="primary"
                                                        className={
                                                            !isAbleToEdit || isEditDisabled ? "btn-unselect-color" :
                                                                selectedDateSch == data.actualDateString ? "btn-select-color" : "btn-unselect-color"}
                                                        onClick={() => onClickDateSchBtn(data)}
                                                >
                                                    <div className='date-btn-container'>
                                                        <span className='month-data'>{data.displayMonth}</span>
                                                        <span className='date-data'>{data.displayDate}</span>
                                                        <span className='year-data'>{data.displayYear}</span>
                                                    </div>
                                                </Button>
                                            </Col>
                                        })
                                    }
                                </Row>
                                <Row>
                                    <Col span={24}>
                                        <Divider/>
                                    </Col>
                                </Row>
                                <Form
                                    layout={"vertical"}
                                    form={radioForm}
                                >
                                    <Form.Item name={"abc"}>
                                        <Row style={{marginTop: 4}}>
                                            <Col xs={24} sm={24} md={24} lg={24} xl={24}
                                                 className='times-col custom_height_for_time_slot'>
                                                <Radio.Group buttonStyle="solid" size="large"
                                                >
                                                    {
                                                        timeSchedules?.verificationTimeSlotsDtoList.map((data, index) => {
                                                            return <Radio.Button
                                                                disabled={data.taken || (!isAbleToEdit || isEditDisabled)}
                                                                key={index}
                                                                onClick={() => setSelectedTimeSlot(data)}
                                                                value={index}>
                                                                {data.slotStart} - {data.slotEnd}</Radio.Button>
                                                        })
                                                    }

                                                </Radio.Group>
                                            </Col>

                                        </Row>
                                    </Form.Item>
                                </Form>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                <Col span={24}>
                    <Divider style={{marginBottom: 12}}></Divider>
                </Col>
                <Col span={24}>
                    <Space style={{float: 'right'}}>
                        <Button size={'large'} disabled={!isAbleToEdit || isEditDisabled}
                                style={{
                                    width: 120,
                                    background: "#FF7400",
                                    color: "white",
                                }} onClick={submitRequest}>Submit</Button>
                    </Space>
                </Col>
            </Row>
            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={previewTitle}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </Spin>
    )
}
export default SignatureChangeRequestComp;